export default __webpack_public_path__ + "static/media/title.beebfc04.svg";